import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "style", "css"];
import React from "react";
import { BaseLink } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
var Link = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var as = _ref.as,
    style = _ref.style,
    css = _ref.css,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BaseLink, _extends({
    ref: forwardedRef
  }, restProps));
});
Link.displayName = "Link";
export default Link;